import PathList from "../../Common/PathList";
import DashboardA from "../../Assets/sidebarActiveicons/DashboardA.png";
import UsersA from "../../Assets/sidebarActiveicons/UsersA.png";
import Dashboard from "../../Assets/SidebarInactiveicons/Dashboard.png";
import Users from "../../Assets/SidebarInactiveicons/Users.png";
import ContentA from "../../Assets/sidebarActiveicons/ContentA.png";
import Content from "../../Assets/SidebarInactiveicons/Content.png";
import NotificationA from "../../Assets/sidebarActiveicons/NotificationA.png";
import Notification from "../../Assets/SidebarInactiveicons/Notification.png";
import ReportA from "../../Assets/sidebarActiveicons/ReportA.png";
import Report from "../../Assets/SidebarInactiveicons/Report.png";
export const NavMenuList = [
  {
    title: "Dashboard",
    path: PathList.Dashboard,
    active: DashboardA,
    icon: Dashboard,
  },
  {
    title: "User Management",
    path: PathList.UserManagement,
    active: UsersA,
    icon: Users,
  },
  // {
  //   title: "Content Management",
  //   path: PathList.ContentManagement,
  //   active: ContentA,
  //   icon: Content,
  // },
  {
    title: "Notification Management",
    path: PathList.NotificationManagement,
    active: NotificationA,
    icon: Notification,
  },
  {
    title: "Reported User",
    path: PathList.ReportManagement,
    active: ReportA,
    icon: Report,
  },
  {
    title: "Feedbacks/Suggestions",
    path: PathList.feedbacks,
    active: ReportA,
    icon: Report,
  },
  {
    title: "Hashtag Management",
    path: PathList.HashtagManagement,
    active: ContentA,
    icon: Content,
  },
  {
    title: "Feedbacks",
    path: PathList.FeedbacksModule,
    active: NotificationA,
    icon: Notification,
  },
  {
    title: "FAQs",
    path: PathList.FAQs,
    active: ContentA,
    icon: Content,
  },
  {
    title: "Comment Reasons",
    path: PathList.CommentReasons,
    active: ReportA,
    icon: Report,
  },
  {
    title: "Reported Comments",
    path: PathList.ReportedComments,
    active: ReportA,
    icon: Report,
  },
  {
    title: "Streak Management",
    path: PathList.Strike,
    active: ReportA,
    icon: Report,
  },
];
